// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1y7Fq","label":"SetPasswdForm_label__2zqIl"};